module.exports = __webpack_public_path__ + "img/iphonex-menu-bg.7218f60e.png";